/* unplugin-vue-components disabled */import script from "./link.vue?vue&type=script&setup=true&lang=ts"
export * from "./link.vue?vue&type=script&setup=true&lang=ts"

import "./link.vue?vue&type=style&index=0&id=b321dec0&lang=scss"

const __exports__ = script;

export default __exports__